import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment as env } from 'src/environments/environment';

/**
 * Common CanDeactivate guard service which can be used by any components
 * Any route component can implement a canDeactivate() function which will
 * define when a user should be warned before navigating away from the page
 */
@Injectable()
export class CanDeactivateGuard {
	canDeactivate(component: ComponentCanDeactivate) {
		return component?.canDeactivate ? component.canDeactivate() : true;
	}
}

export interface ComponentCanDeactivate {
	canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

/**
 * DemoEnvironmentGuard service which can be used to prevent
 * a page from being accessed in non-demo/local UI builds
 */
@Injectable()
export class DemoEnvironmentGuard {
	canActivate() {
		return env.name === 'demo' || env.name === 'local' || env.name === 'demoProd';
	}
}

/**
 * ProdEnvironmentGuard service which can be used to prevent
 * a page from being accessed in production builds
 */
@Injectable()
export class ProdEnvironmentGuard {
	canActivate() {
		return !env.name.toLowerCase().includes('prod');
	}
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
